<!--suppress ALL -->
<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog name="dialog" />
    <!--资源管理左侧菜单-->
    <div id="zy_menu_left" class="col_2_1 w180 zy_menu_left" style="height:100%; overflow:hidden;">
      <span><a @click="editClassification('f', null, '', '0', '0')"  class="add2"></a></span>
      <dl class="main_menu" v-for="(item, idx) in RCTree" :key="item.id">
            <span>
              <dt class="total-scope">
                <a @click="searchByClassification(item.id)" class="single_ellipsis total-scope-name" style="width: 155px" :title="item.name">
                  <a v-if="sort_trigger !== idx" style="cursor: pointer;" title="点击排序" @click.stop="sort_trigger = idx">{{item.sort}} - </a>
                  <span v-if="sort_trigger == idx" >
                    <input type="text" v-model="item.sort" style="width: 20px;">
                    <span style="cursor: pointer; border-radius: 2px; padding: 2px; box-sizing: border-box; background: #ff3633; color: white; font-size: 10px;" @click.stop="classification = item; submitClassification(item.name, item.sort); sort_trigger = null;">保存</span>
                  </span>
                  {{item.name}}
                </a>
                <a href="javascript:void(0);" @click="editClassification('s', null, '', item.id, '0')" class="addSub" title="添加子类"></a>
                <i class="edit" title="编辑" @click="editClassification('f', item.name, item.id, item.parentId, item.parent_ids, item.sort)"></i>
                <a href="javascript:;" title="删除" @click="delRC(item.id)"><i class="del main_menu_del"></i></a><i class="up_icon icon_c"></i>
              </dt>
              <!--此处字数请程序控制不超过7个汉字-->
              <ul class="ul1 total-scope-tan subUL">
                <!--dd v-for="n in item.nodes" :key="n.id" v-dragging="{ item: n, list: item.nodes, sortType: 'name_s_sort' }"-->
                <dd v-for="(n, idx) in item.nodes" :key="n.id">
                  <a @click="searchByClassification(n.id)" class="single_ellipsis subTitle" style="width: 135px" >
                    <a v-if="sort_trigger1 !== idx" style="cursor: pointer;" title="点击排序" @click.stop="sort_trigger1 = idx">{{n.sort}} - </a>
                    <span v-if="sort_trigger1 == idx" >
                      <input type="text" v-model="n.sort" style="width: 20px;">
                      <span style="cursor: pointer; border-radius: 2px; padding: 2px; box-sizing: border-box; background: #ff3633; color: white; font-size: 10px;" @click.stop="classification = n; submitClassification(n.name, n.sort); sort_trigger1 = null;">保存</span>
                    </span>
                    {{n.name}}
                  </a> <i class="edit" title="编辑" @click="editClassification('s', n.name, n.id, n.parentId, n.parent_ids, n.sort)"></i>
                  <a href="javascript:;" title="删除" @click="delRC(n.id)"><i class="del delSub"></i></a>
                </dd>
                <P>
                </P>
              </ul>
            </span>
      </dl>
    </div>
    <!--/资源管理左侧菜单-->
    <!--资源管理右侧列表-->
    <div class="col_2_2 w797 zy_right">
      <div class="zy_right_title">知识库管理</div>
      <div class="gj_top_class">
        <input name="" type="button" class="btn_s_gj" @click="searchByFilter()" /><input name="title" type="text" class="put_gj" v-model="filter.allContent" @keyup.13="searchByFilter()"/>
        <select name="isPublish" class="selcet_put" v-model="filter.isPublish" @change="searchByFilter()">
          <option value="">是否上架</option>
          <option value="1">已上架</option>
          <option value="0">已下架</option>
        </select>
        <select name="isPublic" class="selcet_put" v-model="filter.isOpen" @change="searchByFilter()">
          <option value="">是否公开</option>
          <option value="0">公开</option>
          <option value="1">不公开</option>
        </select>
        <a class="btn btn_add" @click="editResource('')">新增文章</a>
      </div>
      <div class="zy_list" style="min-height:670px;">
        <dl v-for="item in list" :key="item.id">
          <dt style="position: relative;">
            <span class="enroll_badge" style="position: absolute; top: -12px; z-index: 12;">{{item.isPublish==1?'已上架':'已下架'}}</span>
            <div>
              <p class="kz_icon">
                <a style="padding: 0 1px;" href="javascript:void(0);" @click.stop="editResource(item.id)">编辑</a>|
                <a style="padding: 0 1px;" href="javascript:void(0);" @click.stop="del(item.id)">删除</a>|
                <a style="padding: 0 1px;" href="javascript:void(0);" @click.stop="showBox(item)">推送</a> |
                <a v-if="item.isPublish == '0' || !item.isPublish" style="padding: 0 1px;" href="javascript:void(0);" @click.stop="pub(item, '1')">上架</a>
                <a v-if="item.isPublish == '1'" style="padding: 0 1px;" href="javascript:void(0);" @click.stop="pub(item, '0')">下架</a>
              </p>
              <a href="javascript:void(0);">
                <img v-if="item.cover" :src="item.cover"/>
                <img v-if="!item.cover" src="@/assets/images/zy_list_3@2x.png"/>
              </a>
            </div>
          </dt>
          <dd>
            <p>{{item.title}}</p>
            <p class="update">{{item.updateDate}}</p>
          </dd>
        </dl>
        <h5 class="none_ts" v-if="resourceCnt <= 0">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
      </div>
      <div class="zy_list_bottom">
        <dl>
          <dt><!--<input id="sel_1" type="checkbox" v-model="allCheck" style="opacity: 1;" /> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/>--> <!--<input name="" type="button" value="删除所选"  class="btn_zy_bottom" />--> 共{{resourceCnt}}篇文章</dt>
          <dd v-if="resourceCnt > 0">
            <paginate :click-handler="clickCallback" :page-count=pages
                      :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                      :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                      :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                      :first-last-button=$global.paginationOptions.first_last_button
                      :active-class=$global.paginationOptions.active_class
                      :disabled-class=$global.paginationOptions.disabled_class
                      :first-button-text=$global.paginationOptions.first_button_text
                      :last-button-text=$global.paginationOptions.last_button_text
                      :prev-text=$global.paginationOptions.prev_text
                      :next-text=$global.paginationOptions.next_text>
            </paginate>
          </dd>
        </dl>
      </div>
    </div>
    <!--/资源管理右侧列表-->

    <!--添加大类弹出-->
    <div class="tan add_b_menu" style="display:none;">
      <div class="add_con">
        <dl>
          <dt style="height: 45px;">
            <input name="" type="text" v-model="name_f" placeholder="请输入大类名称"/>
          </dt>
          <dt style="height: 95px;">
            <input name="" type="text" v-model="name_f_sort" placeholder="请输入排序"/>
          </dt>
          <dd>
            <input name="" type="button" value="取消" @click="$utils.fadeOut('.add_b_menu')" />　　
            <input type="button" value="确定" class="red_color" @click="submitClassification(name_f, name_f_sort)" /></dd>
        </dl>
      </div>
    </div>
    <!--/添加大类弹出-->
    <!--添加子类弹出-->
    <div class="tan add_s_menu" style="display:none;">
      <div class="add_con">
        <dl>
          <dt style="height: 45px;">
            <input type="text" v-model="name_s" placeholder="请输入子类名称"/>
          </dt>
          <dt style="height: 95px;">
            <input type="text" v-model="name_s_sort" placeholder="请输入排序"/>
          </dt>
          <dd>
            <input type="button" value="取消" @click="$utils.fadeOut('.add_s_menu')" />　　
            <input type="button" value="确定" class="red_color" @click="submitClassification(name_s, name_s_sort)" />
          </dd>
        </dl>
      </div>
    </div>
    <!--/添加子类弹出-->
    <!--停用弹出-->
    <div class="tan stop_btn" style="display:none;">
      <div class="add_con">
        <dl>
          <dt>您确定下架该资源吗？</dt>
          <dd><input name="" type="button" value="取消" @click="$utils.fadeOut('.stop_btn')" />　　<input name="" type="button" value="确定" class="red_color" @click="submitPutOnOff('4', putOnOffArr)" /></dd>
        </dl>
      </div>
    </div>
    <!--/停用弹出-->
    <!--启用弹出-->
    <div class="tan open_btn" style="display:none;">
      <div class="add_con">
        <dl>
          <dt>您确定需要启用吗？</dt>
          <dd><input name="" type="button" value="取消" @click="$utils.fadeOut('.open_btn')" />　　<input name="" type="button" value="确定" class="red_color" @click="submitPutOnOff('5', putOnOffArr)" /></dd>
        </dl>
      </div>
    </div>
    <!--/启用弹出-->
  </div>
</template>
<script>

  import Dropdown from '@/store/modules/dropdowns'
  import {init} from '@/assets/js/public'
  import Paginate from 'vuejs-paginate'
  import ModalBox from '@/components/common/modal/index.vue'
  import rangeManip from '@/components/byl/rangeManip/withInputs.vue'
  import router from '@/router'
  import Bus from '@/utils/bus'
  import { mapState, mapActions } from 'vuex'
  import msgService from '@/utils/sendMsg'
  import config from '@/config'
  import api from '@/api'
  import utils from '@/utils'
  import clonedeep from 'lodash.clonedeep'
  export default {
    components: { Paginate },
    data () {
      return {
        Dropdown: Dropdown,
        filter: {
          pageNo: 1,
          pageSize: 15,
          isOpen: "",
          isPublish: "",
          allContent: ''
        },
        list: [],
        RCTree: [],
        allCheck: '',
        pages: 0,
        resourceCnt: 0,

        name_f: '',
        name_s: '',
        name_f_sort: '0',
        name_s_sort: '0',
        sort_trigger: null,
        sort_trigger1: null,
        dragged_item: {},

        classification: {},
        resourceInfo: {},
        putOnOffArr: [],
        prefix: this.$route.meta.prefix || ''
      }
    },
    created () {
      this.getResourceClassification()
      this.getResources(this.filter)
    },
    mounted () {
      this.$nextTick(() => {
        init()
      })
      Bus.$on('initData_/org/resourceList', (data) => { // 点击菜单“资源管理”重置数据
        this.filter =  {
          pageNo: 1,
          pageSize: 15,
          allContent: "",
          isOpen: "",
          isPublish: ""
        }
        this.getResources(this.filter)
      })
   /*   this.$dragging.$on('dragged', ({ value }) => {
        this.dragged_item = value.list
      })
      this.$dragging.$on('dragend', () => {
        this.dragged_item.forEach((o, idx) => {
          o.parent_ids = '0'
          o.sort = idx
        })
        this.$api.post(this.$global.bylApiPath, '/knowledgeClassification/batchEdit', {knowledgeClassificationList: this.dragged_item}, r => {
          this.getResourceClassification()
        })
      })*/
    },
    computed: {
      player () {
        return this.$refs.videoPlayer.player
      }
    },
    methods: {
      clickCallback (pageNum) {
        this.filter.pageNo = pageNum
        this.getResources(this.filter)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      del (id) {
        if (id) {
          var that = this
          this.confirmBox({
            title: '删除',
            text: '确认删除吗？',
            yes: function () {
              api.post(config.bylApiPath, '/knowledgeInfo/delete', { id: id }, r => {
                that.$toasted.show('删除成功')
                that.getResources(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      // 编辑大分类
      editClassification (type, name, id, parentId, parentIds, sort) {
        if (type == 'f' && name == null) {
          this.$utils.fadeIn('.add_b_menu')
          this.name_f = ''
          this.name_f_sort = ''
        } else if (type == 's' && name == null) {
          this.$utils.fadeIn('.add_s_menu')
          this.name_s = ''
          parentIds = parentIds + ','+parentId
          this.name_s_sort = ''
        } else if (type == 'f' && name != null) {
          this.$utils.fadeIn('.add_b_menu')
          this.name_f = name
          this.name_f_sort = sort
        } else if (type == 's' && name != null) {
          this.$utils.fadeIn('.add_s_menu')
          this.name_s = name
          this.name_s_sort = sort
        }
        this.classification = {
          id: id,
          name: name,
          parentId: parentId || '0',
          parent_ids: parentIds || '0',
          sort: sort
        }
      },
      submitClassification (name, sort) {
        if (!this.classification.parent_ids) { this.classification.parent_ids = '0' }
        if (name && name != '') {
          this.classification.name = name
          this.classification.sort = sort
          this.$api.post(this.$global.bylApiPath, '/knowledgeClassification/edit', this.classification, r => {
            this.$utils.fadeOut('.add_b_menu')
            this.$utils.fadeOut('.add_s_menu')
            this.classification = {}
            this.getResourceClassification()
          })
        }
      },
      searchByClassification (id) {
        this.filter = {
          pageNo: 1,
          pageSize: 15,
          classificationId: id,
          type: "",
          isOpen: "",
          isPublish: ""
        }
        this.getResources(this.filter)
      },
      searchByFilter () {
        this.filter.pageNo = 1
        this.getResources(this.filter)
      },
      getResources (filter) {
        this.$api.post(this.$global.bylApiPath, '/knowledgeInfo/findList', filter, r => {
          this.resourceCnt = r.cntData
          this.pages = Math.ceil(r.cntData / this.filter.pageSize)
          this.list = r.data
        })
      },
      editResource (id) {
        if (id == '') {
          id = 'create'
        }
        this.$router.push({path: this.prefix + '/org/repo/'+ id})
      },
      pub (item, t) {
        let title = (t == '1') ? '上架' : '下架'
        var that = this
        var p = clonedeep(item)
        p.isPublish = t
        this.confirmBox({
          title: title,
          text: '确认' + title + '吗？',
          yes: function () {
            api.post(config.bylApiPath, '/knowledgeInfo/edit', p, r => {
              that.$toasted.show(title + '成功')
              that.getResources(that.filters)
              that.$modal.hide('dialog')
            })
          }
        })
      },
      delRC (id) {
        this.$api.get(this.$global.bylApiPath, '/knowledgeClassification/delete', {id: id}, r => {
          this.getResourceClassification()
        })
      },
      getResourceClassification () {
        this.$api.get(this.$global.bylApiPath, '/knowledgeClassification/findList', {}, r => {
          let tree = r
          this.RCTree = tree.data
        })
      },
      putOnOff (type, id, e) {
        e.stopPropagation();
        this.putOnOffArr = []
        var action
        if (type == 'on') {
          action = '5'
          this.$utils.fadeIn('.open_btn')
        } else if (type == 'off') {
          action = '4'
          this.$utils.fadeIn('.stop_btn')
        }
        this.putOnOffArr.push(id)
      },
      submitPutOnOff (action, idArr) {
        var idStr = ''
        for (var i = 0; i<idArr.length; i++) {
          if (i < idArr.length -1) {
            idStr += idArr[i] + ','
          } else if (i == idArr.length -1) {
            idStr += idArr[i]
          }
        }
        this.$api.get(this.$global.resourceApiPath, '/resource/action/batch', {action: action, ids: idStr}, r => {
          if (action == '4') {
            this.$utils.fadeOut('.stop_btn')
          } else if (action == '5') {
            this.$utils.fadeOut('.open_btn')
          }
          this.getResources(this.filter)
        })
      },
      viewResource (id, type, e) {
        e.stopPropagation();
        this.$api.get(this.$global.resourceApiPath, '/resource/view/' + id, {}, r => {
          this.resourceInfo = r.data
          if (type=='2') {
            this.$refs.videoPlayer.player.src(this.resourceInfo.filePathMp4)
            this.$utils.fadeIn('.resourcePreview')
          } else {
            window.open(this.resourceInfo.filePathMp4, '_black')
          }
        })
      },
      closeViewModal () {
        this.$utils.fadeOut('.resourcePreview')
        this.$refs.videoPlayer.player.pause()
      },
      setMsgObj(item) {
        return {
          title: '[知识库推送]' + item.title,
          content: item.brief
        }
      },
      showBox (item) {
        var that = this
        this.$modal.show(ModalBox, {
          opts: {
            title: '发送消息',
            styles: {
              width: '960',
              height: String(0.8242 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'range',
              template: rangeManip,
              inputs: that.setMsgObj(item),
              outputsKey: 'outputs' // 该组件对外输出数据时，定义的key值
            },
            yes (val) { // 点击确认后要做的事情
              if (val.form && val.form.title && val.form.content && val.form.type && val.form.type.length > 0 && val.people && val.people.length > 0) {
                msgService.sendMsg(val).then((r) => {
                  that.$toasted.show('消息已发送')
                })
              }
            },
            closed () { // 这里要判断, 只有新增状态下需要清空
            }
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .enroll_badge {
    background-color: #f56c6c;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
  }
  .total-scope-tan { background: black; }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/repo/list.vue